import GLightbox from 'glightbox';

export const gLightbox = {
    init: () => {
        GLightbox({ selector: '.glightbox' });
    }
}